import React from 'react';
import { stencilSide } from 'pu-data/SelectOptions';
import { stencilSide as tooltip } from 'pu-data/Tooltips';
import SelectComponent from './SelectComponent';

const StencilThickness = (props) => {
  const { name } = props;
  return (
    <SelectComponent
      label={props.label}
      name={props.name}
      onChange={e => props.onChangeParameter(name, e.target.value)}
      required={props.required}
      options={props.options}
      tooltip={props.tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName}
      inputClassName={props.inputClassName} />
  );
};

StencilThickness.defaultProps = {
  label: 'Stencil Side',
  name: 'stencil_side',
  options: stencilSide,
  tooltip
};

export default StencilThickness;
